<div class="footer">
  <img src="https://cdn.edugogo.ai/public/8af5014f939277070193ad9297f50000/schools/2e091b6e-0cab-4956-b4a9-3b334ffceca8.png" alt="Footer Logo" class="footer-logo" />
</div>